import axios, { AxiosResponse } from 'axios';

interface ICislo {
    mobil: string;
}

const pxKlicSms = (username: string, password: string, lang: string) => {
    return axios({
        method: 'POST',
        url: 'Portal/ReinitMobil',
        data: {
            username,
            password,
            lang
        }
    }).then((resp: AxiosResponse<ICislo>) => resp.data);
};
export default pxKlicSms;
